import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

// 获取首页导航列表
export const getIndexNavListApi = (params: object = {}) => $http.get('/opsapi/listNavigations', params)

// 获取首页导航详情
export const getIndexNavDetailApi = (id: number) => $http.get(`/opsapi/getNavigationDetail`, { id })

// 编辑首页导航
export const editIndexNavApi = (params: object = {}) => $http.post('/opsapi/editNavigation', params)

// 精选品牌列表
export const getSelectedBrandsApi = (params: object = {}) => $http.get('/opsapi/listBrands', params)

// 精选品牌排序
export const sortSelectedBrandsApi = (params: object = {}) => $http.post('/opsapi/updateBrandHomeSort', params)

// 入口图列表
export const getListBannersApi = (params: object = {}) => $http.get('/opsapi/listBanners', params)

// 入口图详情
export const getBannerDetailApi = (id: number) => $http.get(`/opsapi/getBannerDetail`, { id })

// 首页轮播图列表
export const getHomeBroadcastsApi = (params: object = {}) => $http.get('/opsapi/listHomeBroadcasts', params)

// 首页轮播图编辑or添加 
export const saveHomeBroadcastApi = (params: object = {}) => $http.post('/opsapi/saveHomeBroadcast', params)

// 蛋糕用心挑选列表
export const getCakeseBrodcastApi = (params: object = {}) => $http.get('/sys/admin/listCakeBrodcast', params)

// 蛋糕用心挑选添加
export const addCakeseBrodcastApi = (params: object = {}) => $http.post('/sys/admin/addCakeBrodcast', params)

// 清理过期数据
export const cleanExpiredDataApi = (params: object = {}) => $http.post('/opsapi/batchExpire', params)

// 获取首页领券中心列表
export const getHomeTicketListApi = (params: object = {}) => $http.get('/opsapi/ticketList', params)

// 获取首页领券中心详情
export const getHomeTicketDetailApi = (id: number) => $http.get(`/opsapi/getTicketInfo`, { id })

// 首页领券中心添加or编辑
export const saveHomeTicketApi = (params: object = {}) => $http.post('/opsapi/saveTicket', params)

//  首页领券中心上下架
export const toggleTicketStatusApi = (params: object = {}) => $http.post('/opsapi/toggleTicketStatus', params)

// 首页蛋叔频道列表
export const getSpecialListApi = (params: object = {}) => $http.get('/sys/admin/listSpecial', params)

// 首页蛋叔频道添加
export const addSpecialApi = (params: object = {}) => $http.post('/sys/admin/addSpecial', params)

// 首页蛋叔频道上下架
export const deleteSpecialApi = (params: object = {}) => $http.post('/sys/admin/deleteSpecial', params)

// 首页为你推荐列表
export const getHomeRecommendListApi = (params: object = {}) => $http.get('/sys/admin/listRecommend', params)


// 首页为你推荐添加
export const addHomeRecommendApi = (params: object = {}) => $http.post('/sys/admin/addRecommend', params)

// 首页为你推荐删除
export const deleteHomeRecommendApi = (params: object = {}) => $http.post('/sys/admin/deleteRecommend', params)

// 首页为你推荐上下架
export const toggleHomeRecommendStatusApi = (params: object = {}) => $http.post('/sys/admin/doRecommend', params)

// 首页为你推荐修改排序接口
export const HomeRecommendRunkApi = (params: object = {}) => $http.post('/sys/admin/doRecommendRunk', params)

// 首页跑马灯列表接口
export const getHomeMarqueeListApi = (params: object = {}) => $http.get('/sys/admin/listHorselamps', params)

//首页跑马灯添加
export const saveHomeMarqueeApi = (params: object = {}) => $http.post('/sys/admin/addHorselamps', params)

//首页跑马灯删除
export const deleteHomeMarqueeApi = (params: object = {}) => $http.post('/sys/admin/deleteHorselamps', params)

//首页跑马灯终止
export const stopHomeMarqueeApi = (params: object = {}) => $http.post('/sys/admin/operHorselamps', params)

// 首页精选活动列表
export const getHomeHotListApi = (params: object = {}) => $http.get('/sys/admin/listHot', params)

// 添加首页精选活动
export const addHomeHotApi = (params: object = {}) => $http.post('/sys/admin/addHot', params)

// 删除首页精选活动
export const deleteHomeHotApi = (params: object = {}) => $http.post('/sys/admin/deleteHot', params)

// 首页精选活动上下架
export const toggleHomeHotStatusApi = (params: object = {}) => $http.post('/sys/admin/doHot', params)

// 蛋糕轮播列表
export const getCakeseBannerListApi = (params: object = {}) => $http.get('/sys/admin/listCakeBanner', params)

// 添加/修改蛋糕轮播图
export const addCakeseBannerApi = (params: object = {}) => $http.post('/sys/admin/addCakeBanner', params)

// 蛋糕轮播图上下架
export const updateCakeBannerApi = (params:object = {}) => $http.post('/sys/admin/doCakeBanner', params)

// 蛋糕为你推荐删除
export const deleteCakeRecommendApi = (params:object = {}) => $http.post('/sys/admin/deleteCakeRecommend', params)